import { useQuery } from "@tanstack/react-query";

import { getCampaignPaymentType } from "../api/queries";

export const useCampaignPaymentTypeQuery = () => {
  return useQuery(["auth", "campaign-payment-type"], () =>
    getCampaignPaymentType()
  );
};
